
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_main_power",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Fuel')
        },
        value() {
            return this.unitLmsgSensors.humidity?.text//this.$t('Not defined')
        },
        icon() {
            return this.showIcon ? 'unit_dashboard__humidity' : false
        }
    },
}
</script>

<style scoped>

</style>